import { FC, ReactElement } from 'react'

import { TableCell, TableRow } from '../../../../../components'
import { IconButton } from '../../../../../compositions'
import {
    EventLog,
    EventLogActionType,
    EventLogDataType,
    EventLogEntityTypeResource,
    EventLogMailNotification,
    userEntityTypes,
} from '../../../../../entities/EventLog/EventLog'
import { EventLogCategory } from '../../../../../entities/EventLogCategory/EventLogCategory'
import { formatDate } from '../../../../../helpers/date'
import trans from '../../../../../helpers/trans'
import { DateFormat } from '../../../../../types/dateFormatTypes'

import './PzLogRow.scss'

interface PzLogRowProps {
    log: EventLog;
    category?: EventLogCategory;
    onViewLogClick: (log: EventLog) => void;
    className?: string;
    cellClassName?: string;
}

const generateRowTitle = (log: EventLog): string => {
    let nameOfPerson: string | undefined

    if (userEntityTypes.includes(log.type)) {
        nameOfPerson = log.name
    }

    if (log.type === EventLogEntityTypeResource.track) {
        const body = log.items[0]?.data as Record<string, Record<string, string>> | undefined
        nameOfPerson = body?.[EventLogDataType.track]?.user
    }

    const title = nameOfPerson
        ? `${log.message}: ${nameOfPerson}`
        : log.message

    if (log.action !== EventLogActionType.notification || ! log.items[0].data[EventLogDataType.mailNotification]) {
        return title
    }

    const notification = log.items[0].data[EventLogDataType.mailNotification] as EventLogMailNotification

    return `${log.message}: ${notification.subject?.replace('Valkplanner |', '')}`
}

const PzLogRow: FC<PzLogRowProps> = ({
    log,
    category,
    onViewLogClick,
    className = '',
    cellClassName = '',
}): ReactElement => {
    const title = generateRowTitle(log)

    const createdDate = formatDate(log.createdAt, DateFormat.dateTime)

    const handleButtonClick = (): void => {
        onViewLogClick(log)
    }

    return (
        <TableRow
            hasHoverState
            onClick={handleButtonClick}
            className={`pz-log-row ${className}`}
        >
            <TableCell
                className={cellClassName}
                contentClassName="pz-log-row__category"
            >
                {category?.name}
            </TableCell>

            <TableCell className={cellClassName}>
                {title}
            </TableCell>

            <TableCell className={cellClassName}>
                {createdDate}
            </TableCell>

            <TableCell className={`pz-log-row__button-cell ${cellClassName}`}>
                <IconButton
                    hideLabel
                    icon="eye"
                    text={trans('common.open')}
                    onClick={handleButtonClick}
                    className="pz-log-row__button"
                    iconClassName="pz-log-row__button-icon"
                />
            </TableCell>
        </TableRow>
    )
}

export default PzLogRow
